import { Controller } from "@hotwired/stimulus"

// Drives the evolving login form for BRY-442.
//
// Usage:
//   data-controller="login-lookup"
//   data-login-lookup-lookup-url-value="<login_lookup path>"
//   data-login-lookup-signin-url-value="<signin path>"
//   data-login-lookup-lookup-label-value="<email-step submit label>"
//   data-login-lookup-signin-label-value="<signin submit label>"
//   data-login-lookup-show-password-value="true|false"
//
// Targets: form, emailField, passwordSection, submitButton
//
// When the user edits the email after the password field has been revealed,
// the field collapses back, the form action returns to the lookup URL, and
// the submit label reverts. This gives the user a single always-editable
// field without a separate "change email" step.
export default class extends Controller {
  static targets = ["form", "emailField", "passwordSection", "submitButton"]
  static values = {
    lookupUrl: String,
    signinUrl: String,
    lookupLabel: String,
    signinLabel: String,
    showPassword: { type: Boolean, default: false }
  }

  connect() {
    this.lastLookedUpEmail = this.showPasswordValue ? this.emailFieldTarget.value : null
  }

  onEmailInput() {
    if (!this.showPasswordValue) return
    if (this.emailFieldTarget.value === this.lastLookedUpEmail) return

    this.collapseToLookup()
  }

  collapseToLookup() {
    this.showPasswordValue = false
    this.lastLookedUpEmail = null

    this.passwordSectionTarget.hidden = true

    const passwordInput = this.passwordSectionTarget.querySelector("input[type=password]")
    if (passwordInput) passwordInput.value = ""

    this.formTarget.action = this.lookupUrlValue
    this.submitButtonTarget.value = this.lookupLabelValue
  }

  useOtp(event) {
    event.preventDefault()
    this.formTarget.action = `${this.lookupUrlValue}?force_otp=1`
    this.formTarget.requestSubmit()
  }
}
